const suffix = '__time-limited__'
/**
 *
 * @param {*} key
 * @param {*} value
 * @param {*} expired 分钟
 */
export function set (key, value, expired = 9999999) {
  key = `${key}${suffix}`
  localStorage[key] = JSON.stringify({
    value: JSON.stringify(value),
    expires: Date.now() + 1000 * 60 * expired
  })
  return value
}

export function get (key, fullKey) {
  if (!fullKey) {
    key = `${key}${suffix}`
  }
  if (localStorage[key]) {
    const data = JSON.parse(localStorage[key])
    if (data.expires > Date.now()) {
      return JSON.parse(data.value)
    } else {
      localStorage.removeItem(key)
    }
  }
  return undefined
}

export function remove (key) {
  key = `${key}${suffix}`
  localStorage.removeItem(key)
}

function clearExpiresItem () {
  Object.keys(localStorage).forEach(key => {
    if (new RegExp('__time-limited__$').test(key)) {
      get(key, true) // get 带了删除功能了
    }
  })
}

setInterval(clearExpiresItem, 10000)
